import { landscape } from "./terrain";
import { GAME_W, BULLET_GRAVITY, BULLET_HOLE_RADIUS, GAME_H } from "./data";
import { camera } from "./camera";
import { Asset } from "assets.gen";
import { playSoundAt } from "audio";
import { explosions, emitTrail } from "./effects";
import { dt } from "lib/loop";

export interface Bullet {
  x: number;
  y: number;
  _vx: number;
  _vy: number;
  _startX: number;
  _startY: number;
  _dx: number;
  _dy: number;
  active: boolean;
}

export interface BirdFlock {
  x: number;
  y: number;
  active: boolean;
  _t: number;
  _waveDir: number[];
  _waveOffset: number[];
}

export interface CoinEntity {
  x: number;
  y: number;
  w: number;
  h: number;
  active: boolean;
}

export type PickupType = "max_hp" | "heal";

export interface PickupEntity {
  x: number;
  y: number;
  w: number;
  h: number;
  type: PickupType;
  active: boolean;
}

export const bullets: Bullet[] = [];
export const birdsFlocks: BirdFlock[] = [];
export const coins: CoinEntity[] = [];
export const pickups: PickupEntity[] = [];

export function updateBullets(): void {
  for (let i = bullets.length - 1; i >= 0; i--) {
    const b = bullets[i];
    if (!b.active) {
      bullets.splice(i, 1);
      continue;
    }
    b._vy += BULLET_GRAVITY * dt;
    b._dx += b._vx * dt;
    b._dy += b._vy * dt;
    b.x = b._startX + b._dx;
    b.y = b._startY + b._dy;

    emitTrail(b.x, b.y, b._vx, "hsl(15, 100%, 55%)");

    if (b.x < camera.x - 10 || b.x > camera.x + GAME_W + 50 || b.y > GAME_H + 10 || b.y < -10) {
      bullets.splice(i, 1);
      continue;
    }

    const { top, bottom } = landscape.getPlaceOffsets(b.x | 0);
    if (b.y <= top || b.y >= bottom) {
      playSoundAt(Asset.sfx_bullet_hit, camera.worldToScreenX(b.x), GAME_W, 1);
      landscape.makeHole(b.x, b.y, BULLET_HOLE_RADIUS);
      explosions.push({ x: b.x, y: b.y, count: 20, t: 0, big: false });
      bullets.splice(i, 1);
    }
  }
}

export function resetBullets(): void {
  bullets.length = 0;
}

export function resetBirds(): void {
  birdsFlocks.length = 0;
}

export function resetCoins(): void {
  coins.length = 0;
}

export function resetPickups(): void {
  pickups.length = 0;
}
